// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'
import { UpdatedLabeledInputWrapper } from 'components/Form/updated/UpdatedLabeledInput/styles'

// styles allow for variable height of the <textarea />
// based on its inherited rows property.

export const UpdatedLabeledTextAreaWrapper = styled(UpdatedLabeledInputWrapper)`
  grid-template-rows: repeat(2, auto) 1fr;

  > .input {
    height: auto;

    &:disabled {
      cursor: not-allowed;
    }
  }
`
